import {Observable, Subscription} from 'rxjs';

import WatermarkStatus from '../Constants/WatermarkStatus';
import IFrameStore     from '../Interfaces/IFrameStore';

const subscribeToWatermarkStatus = (
    watermarkStatus$: Observable<WatermarkStatus>,
    frameStore: IFrameStore
): Subscription =>
    watermarkStatus$
        .subscribe(status => {
            switch (status) {
                case WatermarkStatus.HIDDEN:
                    frameStore.actions.hideWatermark();

                    break;
                default:
                    frameStore.actions.showWatermark(status);
            }
        });

export default subscribeToWatermarkStatus;